import React, { Component } from 'react';
import { DatePicker, Input, Button, Select, Modal } from 'antd';
import FloatingInputs from "../../components/FloatingLabel";
import { ArrowLeftOutlined, LoadingOutlined } from '@ant-design/icons';
import { withRouter } from "react-router-dom";
import axios from "axios";
import Map from '../../components/Map';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import moment from 'moment';
import i18next from 'i18next';
import { Trash2 } from "lucide-react"; // Importing Lucide Trash icon
import Trash from '../../assets/images/icons/trash.svg'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const { Option } = Select;

const { TextArea } = Input;

const mapStateToProps = (props) => {
    return {
        user_location: props.userLocation
    }
}

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});


class PostTask extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: undefined,
            date_format: 'DD-MM-YYYY',
            categories: [],
            sub_categories: [],
            is_location_ModalVisible: false,
            location2: '',
            description : '',
            location1: '',
            show_hide_map: false,
            chosen_subcat: 'Select Sub Category',
            is_disabled: false,
            images: [],  // New: Image file state,
            countries: [], // New state for countries
            cities: [], // New state for cities
            selectedCountry: '', // New state to track selected country
            selectedCity: '',
            country_err: '', // Error message for country selection
            city_err: '', //
            image_err: '',
            description_err: '',
            activeIndex: null, 
        }
    }
    onChange = value => {
        this.setState({ value });
    };
    UNSAFE_componentWillMount = () => {
        this.get_categories();
        this.get_countries(); // Fetch countries on mount
        // this.get_cities(); // Fetch countries on mount

    }


    // Fetch countries
    get_countries = () => {
        axios.get(`${process.env.REACT_APP_BASE_URL}/web/api/v1/countries`)
            .then(res => {
                if (res.data.status_code === 200) {
                    this.setState({ countries: res.data.countries });
                } else {
                    console.log('MES', res.data.message);
                }
            });
    }


    // Fetch cities based on selected country
    get_cities = (countryId) => {
        axios.get(`${process.env.REACT_APP_BASE_URL}/web/api/v1/cities/${countryId}`) // Change `?countryId=` to `/${countryId}`
            .then(res => {
                console.log("Cities API Response:", res.data); // Debugging

                if (res.data.status_code === 200) {
                    this.setState({ cities: res.data.cities });
                } else {
                    console.log("No cities found:", res.data.message);
                    this.setState({ cities: [] });
                }
            })
            .catch(err => console.error("Error fetching cities:", err));

    };

    // Handle country selection
    handleCountryChange = (value) => {
        this.setState({ selectedCountry: value, selectedCity: '' }, () => {
            this.get_cities(value); // Fetch cities based on selected country
        });
    }

    // Handle city selection
    handleCityChange = (value) => {
        this.setState({ selectedCity: value });
    }


    get_categories = () => {
        var general_info = JSON.parse(localStorage.getItem('general_info'));
        var user_info = JSON.parse(localStorage.getItem('user'));
        this.setState({ general_info: general_info, user_info: user_info }, () => {
            if (general_info.instant_location === "true") {
                this.get_geo_location();
            }
        })
        axios.get(`${process.env.REACT_APP_BASE_URL}/web/api/v1/categories`)
            .then(res => {
                if (res.data.status_code === 200) {
                    console.log('categoriy:',res.data.category);
                    
                    this.setState({
                        categories: res.data.category,
                    });
                }
                else {
                    console.log(res.data.message);
                }
            })
    }

    //countries
    // get_countries = () => {
    //     axios.get(`${process.env.REACT_APP_BASE_URL}/web/api/v1/countries`)
    //         .then(res => {
    //             if (res.data.status_code === 200) {
    //                 this.setState({ countries: res.data.countries });
    //             }
    //         })
    //         .catch(err => console.log("Error fetching countries", err));
    // };

    // handleCountryChange = (event) => {
    //     const selectedCountry = event.target.value;
    //     this.setState({ country: selectedCountry, city: "", cities: [] });

    //     axios.get(`${process.env.REACT_APP_BASE_URL}/web/api/v1/cities?country=${selectedCountry}`)
    //         .then(res => {
    //             if (res.data.status_code === 200) {
    //                 this.setState({ cities: res.data.cities });
    //             }
    //         })
    //         .catch(err => console.log("Error fetching cities", err));
    // };

    // handleImageUpload = (event) => {
    //     const file = event.target.files[0];
    //     this.setState({ image: file });
    // };


    // Handle file selection from input
    handleImageUpload = (event) => {
        const files = event.target.files || event.dataTransfer.files;
        if (!files.length) return;

        let newImages = [...this.state.images];

        for (let file of files) {
            if (newImages.length >= 15) break; // Limit to 15 images

            const reader = new FileReader();
            reader.onload = (e) => {
                this.setState((prevState) => ({
                    images: [...prevState.images, { file, url: e.target.result }]
                }));
            };
            reader.readAsDataURL(file);
        }
    };

    // Handle drag over event
    handleDragOver = (event) => {
        event.preventDefault();
    };

    // Remove an image
    removeImage = (index) => {
        this.setState((prevState) => ({
            images: prevState.images.filter((_, i) => i !== index)
        }));
    };

    getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
        var R = 6371; // Radius of the earth in km
        var dLat = this.deg2rad(lat2 - lat1);  // deg2rad below
        var dLon = this.deg2rad(lon2 - lon1);
        var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2)
            ;
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c; // Distance in km
        return d;
    }

    deg2rad = (deg) => {
        return deg * (Math.PI / 180)
    }
    
    get_subcategories = (value) => {
        const config = {
            headers: {
                'Content-type': 'application/x-www-form-urlencoded'
            }
        }
        this.setState({ chosen_cat: value, chosen_subcat: 'Select Sub Category', chosen_service: 'Select Service', sub_categories: [], services: [] }, () => {
            var cat_id = value;
            if (cat_id !== '') {
                const params = new URLSearchParams()
                params.append('category_id', cat_id)
                axios.post(`${process.env.REACT_APP_BASE_URL}/web/api/v1/category_by_id`, params, config)
                    .then(res => {
                        // console.log('bread_1');
                        console.log(res.data)
                        if (res.data.status_code === 200) {
                            this.setState({
                                category_info: res.data.category[0],
                            })
                        }
                    });
            }
        });

        var cat_id = value;
        if (cat_id !== '') {
            const params = new URLSearchParams()
            params.append('category_id', cat_id)
            axios.post(`${process.env.REACT_APP_BASE_URL}/web/api/v1/category_by_id`, params, config)
                .then(res => {
                    if (res.data.status_code === 200) {
                        this.setState({
                            category_type: res.data.category[0].parent_category_type,
                        })
                    }
                });
        }
        const params1 = new URLSearchParams();
        params1.append('parent_category_id', value);
        axios.post(`${process.env.REACT_APP_BASE_URL}/web/api/v1/subcategories`, params1, config)
            .then(res => {
                // console.log('result is here');
                // console.log(res);
                if (res.data.status_code === 200) {
                    this.setState({
                        sub_categories: res.data.subcategory
                    });
                }
                else {
                    console.log(res.data.message);
                }
            })
    }

    location_modal_close = () => {
        this.setState({
            is_location_ModalVisible: false,
            show_hide_map: false,
        });
    }
    set_location = () => {
        var location_type = this.state.general_info && this.state.general_info.instant_location;
        var location_input_id = this.state.location_input_id;
        if (location_type === 'true') {
            if (location_input_id === 1) {
                this.setState({
                    location1: this.props.user_location.address && this.props.user_location.address,
                    source_lat: this.props.user_location.lat && this.props.user_location.lat,
                    source_lng: this.props.user_location.lng && this.props.user_location.lng,
                    is_location_ModalVisible: false,
                    show_hide_map: false,
                })
            }
            else {
                this.setState({
                    location2: this.props.user_location.address && this.props.user_location.address,
                    dest_lat: this.props.user_location.lat && this.props.user_location.lat,
                    dest_lng: this.props.user_location.lng && this.props.user_location.lng,
                    is_location_ModalVisible: false,
                    show_hide_map: false,
                })
            }
        }
        else {
            var exist_city = this.state.general_info.cities.includes(this.state.manual_location);
            if (!exist_city) {
                this.setState({ ex_location_err: i18next.t('Entered location is not exist!') });
            }
            else {
                if (location_input_id === 1) {
                    this.setState({ location1: this.state.manual_location, manual_location: '', is_location_ModalVisible: false, show_hide_map: false, ex_location_err: '' })
                }
                else {
                    this.setState({ location2: this.state.manual_location, manual_location: '', is_location_ModalVisible: false, show_hide_map: false, ex_location_err: '' })
                }
            }
        }
    }


    get_geo_location = () => {
        if (localStorage.getItem('user') === null) {
            this.props.history.push("/user/user-login");
        }
        else if (localStorage.getItem('user') !== null) {
            var userinfo = JSON.parse(localStorage.getItem('user'));
            if (userinfo.type !== 'user') {
                this.props.history.push("/tasker");
            }
        }
        var rm = this;
        rm.setState({ lat: 30.000000, lon: 31.000000 });
        var init_pos = {
            lat: 30.000000,
            lng: 31.000000
        }
        rm.setState({ position: init_pos, gps_flag: false });
    }
    date_of_service = (date, dateString) => {
        this.setState({
            date_of_service: date
        })
    }
    get_service = (value) => {
        this.setState({ chosen_service: value });
    }
    get_services = (value) => {
        this.setState({
            chosen_service: "Select Service",
            services: []
        })
        const config = {
            headers: {
                'Content-type': 'application/x-www-form-urlencoded'
            }
        }
        const params = new URLSearchParams();
        params.append('parent_category_id', this.state.chosen_cat);
        params.append('subcategory_id', value);
        axios.post(`${process.env.REACT_APP_BASE_URL}/web/api/v1/services`, params, config)
            .then(res => {
                console.log('result is here');
                console.log(res);
                if (res.data.status_code === 200) {
                    this.setState({ services: res.data.services, chosen_subcat: value });
                }
                else {
                    console.log(res.data.message);
                }
            })
    }
    save_need = () => {
        console.log('enters saveneed');
        // console.log('SAVEERR', err);
        this.setState({
            is_disabled: true,
        })
        var user_info = JSON.parse(localStorage.getItem('user'));
        var err = 0;
        var before_decimal = 6;
        var after_decimal = 2;
        //image validation
        // if (!this.state.images || this.state.images.length === 0) {
        //     this.setState({ image_err: i18next.t("At least one image is required!"), is_disabled: false });
        //     this.task_name.scrollIntoView({ behavior: "smooth" });
        //     err++;
        // } else if (this.state.images.length > 15) {
        //     this.setState({ image_err: i18next.t("You can upload up to 15 images only!"), is_disabled: false });
        //     this.task_name.scrollIntoView({ behavior: "smooth" });
        //     err++;
        // } else {
        //     this.setState({ image_err: "" });
        // }


        if (!this.state.images || this.state.images.length === 0) {
            this.setState({ 
                image_err: i18next.t("At least one image is required!"), 
                is_disabled: false 
            }, () => {
                if (this.task_name) {
                    setTimeout(() => {
                        this.task_name.scrollIntoView({ behavior: "smooth", block: "center" });
                    }, 100);
                }
            });
            err++;
            return; // 🚀 Exit early to prevent other checks
        }
        
        
        if (this.state.images.length > 15) {
            this.setState({ 
                image_err: i18next.t("You can upload up to 15 images only!"), 
                is_disabled: false 
            }, () => {
                if (this.task_name) {
                    setTimeout(() => {
                        this.task_name.scrollIntoView({ behavior: "smooth", block: "center" });
                    }, 100);
                }
            });
            err++;
            return; // 🚀 Exit early to prevent other checks
        }

        // Ensure each image has a valid format and size
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        const maxSize = 5 * 1024 * 1024; // 5MB

        let imageError = "";  // Store error message
        let shouldScroll = false;  // Track if we need to scroll

        for (let i = 0; i < this.state.images.length; i++) {
            let image = this.state.images[i].file;

            if (!allowedTypes.includes(image.type)) {
                imageError = i18next.t("Invalid image format! Only JPG, PNG allowed.");
                shouldScroll = true;
                break;
            }
        
            if (image.size > maxSize) {
                imageError = i18next.t("Image size should not exceed 5MB!");
                shouldScroll = true;
                break;
            }
        }

        if (imageError) {
            this.setState({ image_err: imageError, is_disabled: false }, () => {
                if (shouldScroll && this.task_name) {
                    setTimeout(() => {
                        this.task_name.scrollIntoView({ behavior: "smooth", block: "center" });
                    }, 100);
                }
            });
            err++;
        } else {
            this.setState({ image_err: "" });
        }

        if (!this.state.task_name || (this.state.task_name && this.state.task_name === '')) {
            this.setState({ task_name_err: i18next.t("Title is required!"), is_disabled: false, });
            this.task_name.scrollIntoView({ behavior: "smooth" });
            err++;
        }
        else {
            this.setState({ task_name_err: "" });
        }
        if (!this.state.chosen_cat || (this.state.chosen_cat && (this.state.chosen_cat === '' || this.state.chosen_cat === 'Select Category'))) {
            this.setState({ cat_err: i18next.t("Category is required!"), is_disabled: false, });
            this.task_name.scrollIntoView({ behavior: "smooth" });
            err++;
        }
        else {
            this.setState({ cat_err: "" });
        }
        // console.log('chosensubcat:',this.state.chosen_subcat);return;
        
        if (!this.state.chosen_subcat || (this.state.chosen_subcat && (this.state.chosen_subcat === '' || this.state.chosen_subcat === 'Select Sub Category'))) {
            this.setState({ sub_cat_err: i18next.t("Sub Category is required!"), is_disabled: false, });
            this.task_name.scrollIntoView({ behavior: "smooth" });
            err++;
        }
        else {
            this.setState({ sub_cat_err: "" });
        }


        if (!this.state.selectedCountry || (this.state.selectedCountry && (this.state.selectedCountry === '' || this.state.selectedCountry === 'Select Country'))) {
            this.setState({ country_err: i18next.t("Country is required!"), is_disabled: false, });
            this.task_name.scrollIntoView({ behavior: "smooth" });
            err++;
        }
        else {
            this.setState({ country_err: "" });
        }


        if (!this.state.selectedCity || (this.state.selectedCity && (this.state.selectedCity === '' || this.state.selectedCity === 'Select City'))) {
            this.setState({ city_err: i18next.t("City is required!"), is_disabled: false, });
            this.task_name.scrollIntoView({ behavior: "smooth" });
            err++;
        }
        else {
            this.setState({ city_err: "" });
        }

        // this.state.selectedCountry

        var current_date = new Date();
        var chosen_date = new Date(this.state.date_of_service);
        chosen_date.setHours(0, 0, 0, 0);
        if (!this.state.date_of_service || (this.state.date_of_service && this.state.date_of_service === '')) {
            this.setState({ date_err: i18next.t('Date is required!'), is_disabled: false, });
            this.task_name.scrollIntoView({ behavior: "smooth" });
            err++;
        }
        else if (this.state.date_of_service && chosen_date < current_date) {
            this.setState({ date_err: i18next.t('Choose Future Date!'), is_disabled: false, });
            this.task_name.scrollIntoView({ behavior: "smooth" });
            err++;
        }
        else {
            this.setState({ date_err: '' });
        }

        if (!this.state.sale_price || (this.state.sale_price && this.state.sale_price === '')) {
            this.setState({ task_price_err: i18next.t("Price is required!"), is_disabled: false, });
            err++;
        }else if(Number(this.state.sale_price) <= 0){
            this.setState({ task_price_err: i18next.t("Price should be more than 0"), is_disabled: false, });
            err++;
        }
        else {
            this.setState({ task_price_err: "" });
        }
          if(!this.state.description || (this.state.description && this.state.description === '')) {
            this.setState({ description_err : i18next.t('Description is required!'),is_disabled : false  });
            err++;
        }
        else {
            this.setState({ description_err : ''  });
        }

        // if (Number(this.state.sale_price <=0)) {
        //     this.setState({ task_price_err: i18next.t("Price should be more than 0!"), is_disabled: false, });
        //     err++;
        // }
        // else {
        //     this.setState({ task_price_err: "" });
        // }

        
        console.log('before error');
        if (err === 0) {
            console.log('after error');
            // let accessToken = localStorage.getItem('access_token');
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    // 'Authorization' : `JWT ${accessToken}`
                }
            };
            console.log('PARUSER',user_info.user_id);

            const params = new FormData();
            params.append('date', this.state.date_of_service || '');
            params.append('parent_category_id', this.state.category_info?.parent_category_id || '');
            params.append('subcategory_id', this.state.chosen_subcat || '');
            params.append('user_id', user_info.user_id);
            params.append('sale_price', this.state.sale_price || '');
            params.append('name', this.state.task_name || '');
            params.append('country', this.state.selectedCountry || '');
            params.append('city', this.state.selectedCity || '');
            params.append('description', this.state.description);

            // Add images from the drag-and-drop section
            this.state.images.forEach((image, index) => {
                params.append(`images`, image.file); // Adjust based on your image data structure
            });
            console.log( 'DEVIE',`${process.env.REACT_APP_BASE_URL}/web/api/v1/user/addneed`);

            axios.post(`${process.env.REACT_APP_BASE_URL}/web/api/v1/user/addneed`,
                params, config)
                .then(res => {
                    console.log('RESUE',res);
                    if (res.status === 200) {
                        if (res.data.status_code === 200) {

                            Toast.fire({
                                icon: 'success',
                                title: i18next.t('Review Submitted Successfully!')
                            });
                            var obj = {};
                            obj.need_id = res.data.item_id;
                            this.props.history.push('/user/my-listing', obj);

                        }
                        else if (res.data.status_code === 401) {
                            this.setState({
                                is_disabled: false,
                            })
                            localStorage.removeItem('access_token');
                            localStorage.removeItem('user');
                            this.props.history.push('/');
                            window.location.reload(false);
                        }
                        else {
                            this.setState({
                                is_disabled: false,
                            })
                            Toast.fire({
                                icon: 'warning',
                                title: "Something Went wrong!"
                            });
                        }
                    }
                }).catch((err)=>{
                    console.log('ROUTEERROR',err);
                })
        }

    }
    isNumber = (e) => {
        var rgx = /^[0-9]*\.?[0-9]*$/;
        var split_price = e.target.value.split('.');
        if (rgx.test(e.target.value)) {
            if ((split_price[0] && split_price[0].length !== undefined && split_price[0].length <= 6)) {
                if (!split_price[1]) {
                    this.setState({ need_price: e.target.value })
                }
                else {
                    if ((split_price[1] && split_price[1].length !== undefined && split_price[1].length <= 2)) {
                        this.setState({ need_price: e.target.value })
                    }
                }

            }
        }
        if (e.target.value.length === 0) {
            this.setState({ need_price: e.target.value })
        }
    }
    disabledDate = (current) => {
        return moment() >= current || moment().add(1, 'month') <= current;
    }
    trigger_location_autocomplete = () => {
        // alert('autohi');
        this.autocomplete(document.getElementById("manual_location"), this.state.general_info.cities);
        var el = document.getElementById('manual_location');
        el.dispatchEvent(new Event('input'));
    }
    autocomplete(inp, arr) {
        var currentFocus;
        var rm = this;
        /*execute a function when someone writes in the text field:*/
        inp.addEventListener("input", function (e) {
            var a, b, i, val = this.value;
            /*close any already open lists of autocompleted values*/
            closeAllLists();
            // if (!val) { return false;}
            currentFocus = -1;
            /*create a DIV element that will contain the items (values):*/
            a = document.createElement("DIV");
            a.setAttribute("id", this.id + "autocomplete-list");
            a.setAttribute("class", "autocomplete-items");
            /*append the DIV element as a child of the autocomplete container:*/
            this.parentNode.appendChild(a);
            /*for each item in the array...*/
            for (i = 0; i < arr.length; i++) {
                /*check if the item starts with the same letters as the text field value:*/
                if (arr[i].substr(0, val.length).toUpperCase() === val.toUpperCase()) {
                    /*create a DIV element for each matching element:*/
                    b = document.createElement("DIV");
                    /*make the matching letters bold:*/
                    b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";
                    b.innerHTML += arr[i].substr(val.length);
                    /*insert a input field that will hold the current array item's value:*/
                    b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
                    /*execute a function when someone clicks on the item value (DIV element):*/
                    b.addEventListener("click", function (e) {
                        /*insert the value for the autocomplete text field:*/
                        inp.value = this.getElementsByTagName("input")[0].value;
                        rm.setState({ manual_location: inp.value });
                        /*close the list of autocompleted values,
                        (or any other open lists of autocompleted values:*/
                        closeAllLists();
                    });
                    a.appendChild(b);
                }
            }
        });
        /*execute a function presses a key on the keyboard:*/
        inp.addEventListener("keydown", function (e) {
            var x = document.getElementById(this.id + "autocomplete-list");
            if (x) x = x.getElementsByTagName("div");
            if (e.keyCode === 40) {
                /*If the arrow DOWN key is pressed,
                increase the currentFocus variable:*/
                currentFocus++;
                /*and and make the current item more visible:*/
                addActive(x);
            } else if (e.keyCode === 38) { //up
                /*If the arrow UP key is pressed,
                decrease the currentFocus variable:*/
                currentFocus--;
                /*and and make the current item more visible:*/
                addActive(x);
            } else if (e.keyCode === 13) {
                /*If the ENTER key is pressed, prevent the form from being submitted,*/
                e.preventDefault();
                if (currentFocus > -1) {
                    /*and simulate a click on the "active" item:*/
                    if (x) x[currentFocus].click();
                }
            }
        });
        function addActive(x) {
            /*a function to classify an item as "active":*/
            if (!x) return false;
            /*start by removing the "active" class on all items:*/
            removeActive(x);
            if (currentFocus >= x.length) currentFocus = 0;
            if (currentFocus < 0) currentFocus = (x.length - 1);
            /*add class "autocomplete-active":*/
            x[currentFocus].classList.add("autocomplete-active");
        }
        function removeActive(x) {
            /*a function to remove the "active" class from all autocomplete items:*/
            for (var i = 0; i < x.length; i++) {
                x[i].classList.remove("autocomplete-active");
            }
        }
        function closeAllLists(elmnt) {
            /*close all autocomplete lists in the document,
            except the one passed as an argument:*/
            var x = document.getElementsByClassName("autocomplete-items");
            for (var i = 0; i < x.length; i++) {
                if (elmnt !== x[i] && elmnt !== inp) {
                    x[i].parentNode.removeChild(x[i]);
                }
            }
        }
        /*execute a function when someone clicks in the document:*/
        document.addEventListener("click", function (e) {
            closeAllLists(e.target);
        });
    }
    get_to_back = () => {
        this.props.history.goBack();
    }
    handleClick = (index) => {
        this.setState({ activeIndex: index });
    };
    render() {
        var settings = {
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 9.5,
            slidesToScroll: 1,
            swipeToSlide: true,

            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 8,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 6,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
                }
              ]
        };
        return (
            <React.Fragment>

                <div className="container">
                    <div className="pt-5">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 class="fM" ref={(el) => { this.task_name = el; }}>{i18next.t('Post Your Business for Sale')}</h4>
                            <div className="d-flex p-3 align-items-center hover-cont" onClick={this.get_to_back}>
                                <ArrowLeftOutlined />
                                &nbsp;
                                <span>{i18next.t("Back")} </span>
                            </div>
                        </div>
                        {/* <div className="pl-0 pl-md-5"> */}
                        <div>

                            {/* Image Preview Section */}


                            {/* Drag & Drop Box */}
                            <div
                                onDragOver={this.handleDragOver}
                                onDrop={this.handleImageUpload}
                                className="upload_input"
                                style={{
                                    border: "2px dashed #aaa",
                                    padding: "40px",
                                    textAlign: "center",
                                    cursor: "pointer",
                                    backgroundColor: "#f9f9f9"
                                }}
                            >
                                <p>Upload Upto 15 Image</p>
                                <p style={{ fontSize: "14px", color: "#666" }}>Drag and drop images here or click to upload</p>
                                <input
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    onChange={this.handleImageUpload}
                                    id="fileInput"
                                />
                                <p className="text-danger">{this.state.image_err}</p>
                            </div>
                            <Slider {...settings} className='sliderupload_div'>
                                {this.state.images.map((image, index) => (
                                    <div key={index} className={`sliderupload_card ${this.state.activeIndex === index ? "active" : ""}`}
                                        onClick={() => this.handleClick(index)}>
                                        <div className='slideruploadimg_div'>
                                            <img src={image.url} alt="Preview" />
                                        </div>
                                        <button onClick={() => this.removeImage(index)}>
                                            <img src={Trash} />
                                        </button>
                                    </div>
                                ))}
                            </Slider>


                            <div className="col-12 col-sm-12 col-md-10 col-lg-8 col-xl-6 px-0">

                                <div className="">
                                    <p class="mb-3 fM">{i18next.t('Title')} </p>
                                    <div className="mb-3">
                                        <Input size="large" maxLength="60" placeholder={i18next.t("Enter business title")} onChange={(e) => { this.setState({ task_name: e.target.value }) }} value={this.state.task_name} />
                                        <p className="text-danger">{this.state.task_name_err}</p>
                                    </div>

                                    <p class="mb-3 fM" ref={(input) => { this.category_id = input; }}>{i18next.t("Select Category")} </p>
                                    <div className="mb-3">
                                        <Select className="w-100" defaultValue={i18next.t("Select your Category")} onChange={this.get_subcategories}>
                                            {
                                                this.state.categories.length > 0 &&
                                                this.state.categories
                                                .filter(i => i.section && i.section === 'business_sale') // Only show business_sale categories
                                                .map((i, k) => {

                                                    return (
                                                        <Option key={k} value={i.parent_category_id}>{i.parent_category_name}</Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                        <p className="text-danger">{this.state.cat_err}</p>
                                    </div>

                                    <p class="mb-3 fM" ref={(input) => { this.sub_category_id = input; }}>{i18next.t("Sub Category")} </p>
                                    <div className="mb-3">
                                        <Select className="w-100" defaultValue={i18next.t("Select your Sub Category")} value={this.state.chosen_subcat} onChange={this.get_services}>
                                            {
                                                this.state.sub_categories.length > 0 &&
                                                this.state.sub_categories.map((i, k) => {
                                                    return (
                                                        <Option key={k} value={i.subcategory_id}>{i.subcategory_name}</Option>
                                                    )
                                                })
                                            }

                                        </Select>
                                        <p className="text-danger">{this.state.sub_cat_err}</p>

                                    </div>

                                </div>



                                {/* Country Dropdown */}

                                {/* Country Dropdown */}
                                <p class="mb-3 fM" >
                                    {i18next.t("Select Country")}
                                </p>
                                <div className="mb-3">
                                    <Select
                                        className="w-100"
                                        value={this.state.selectedCountry}
                                        onChange={this.handleCountryChange}
                                    >
                                        <Option value="">{i18next.t("Select Country")}</Option>
                                        {this.state.countries.map((country, k) => (
                                            <Option key={k} value={country.name}>
                                                {country.name}
                                            </Option>
                                        ))}
                                    </Select>
                                    <p className="text-danger">{this.state.country_err}</p>
                                </div>

                                {/* City Dropdown */}
                                <p class="mb-3 fM" >
                                    {i18next.t("Select City")}
                                </p>
                                <div className="mb-3">
                                    <Select
                                        className="w-100"
                                        value={this.state.selectedCity}
                                        onChange={this.handleCityChange}
                                        disabled={!this.state.selectedCountry} // Disable if no country is selected
                                    >
                                        <Option value="">{i18next.t("Select City")}</Option>
                                        {this.state.cities.map((city, k) => (
                                            <Option key={k} value={city}>
                                                {city}
                                            </Option>
                                        ))}
                                    </Select>
                                    <p className="text-danger">{this.state.city_err}</p>
                                </div>


                                <p class="mb-3 fM">{i18next.t('Sale price')} </p>
                                <div className="mb-3">
                                    <Input size="large" placeholder={i18next.t("Enter Sale Price")} onChange={(e) => { this.setState({ sale_price: e.target.value }) }} value={this.state.sale_price}  onKeyUp={(e) => {
            const value = e.target.value;
            if (!/^\d*\.?\d*$/.test(value)) {  
                e.target.value = value.replace(/[^0-9.]/g, ""); // Remove non-numeric characters
                this.setState({ sale_price: e.target.value });
            }
        }} />
                                    <p className="text-danger">{this.state.task_price_err}</p>
                                </div>




                                <div className="mt-4">
                                    <p class="mb-3 fM" ref={(input) => { this.service_date = input; }}>{i18next.t("Start your date")}  </p>
                                    <div className="mb-3">
                                        <DatePicker inputReadOnly={true} disabledDate={this.disabledDate} onChange={this.date_of_service} format={this.state.date_format} size="large" placeholder={i18next.t("Choose your date")} />
                                        <p className="text-danger">{this.state.date_err}</p>
                                    </div>
                                </div>

                                {/*  */}

                                    <p className="mb-3 fM">{ i18next.t("Description") }</p>
                                        <div className="col-12 px-0 mb-4">

                                            <TextArea
                                                maxLength={300} 
                                                placeholder={ i18next.t("Enter your details of your task") }
                                                onChange={(e)=> { this.setState({ description : e.target.value }) }}
                                                value={ this.state.description }
                                            />
                                            <p className="text-danger">{ this.state.description_err && this.state.description_err }</p>
                                        </div>


                                <div className="col-12 px-0">
                                    <div className="row mt-4">
                                        <div className="col-12 align-self-center pl-sm-2">
                                            <Button disabled={this.state.is_disabled} onClick={this.save_need} size="large" className="Btns PrimaryBtn lg fM mb-2 mb-sm-0" block>{this.state.is_disabled === true ? <LoadingOutlined /> : i18next.t("Submit for review")}</Button>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                    <Modal title={i18next.t("Enter Location")} onCancel={this.location_modal_close} footer={[<Button onClick={this.set_location}>{i18next.t("Set Location")}</Button>]} visible={this.state.is_location_ModalVisible} >
                        {
                            this.state.general_info && this.state.general_info.instant_location === "true" ?
                                <>

                                    <div className="h-330">
                                        {
                                            this.state.show_hide_map === true &&
                                            <Map
                                                google={this.props.google}
                                                center={this.state.position && this.state.position}
                                                height='300px'
                                                zoom={this.state.position && this.state.position.lat === 30.000000 && this.state.position.lng === 31.000000 ? 0 : 15}
                                            />
                                        }
                                    </div>
                                    <div>
                                        {/* <Button onClick={this.get_geo_location} type="primary" shape="circle" icon={<AimOutlined />} size="large" /> */}
                                    </div>
                                </>
                                :
                                <div className="floatingLabelStyle p-4 py-5 px-sm-5 text-center">
                                    <div>
                                        <FloatingInputs labelName={i18next.t("Search Location")}>

                                            <input type="text" id="manual_location" placeholder=" " onChange={(e) => this.setState({ manual_location: e.target.value })} onMouseEnter={this.trigger_location_autocomplete} autoComplete="off" value={this.state.manual_location} />
                                            <p className="text-danger">{this.state.ex_location_err && this.state.ex_location_err}</p>
                                        </FloatingInputs>

                                    </div>

                                </div>
                        }


                    </Modal>
                </div>
            </React.Fragment>
        );
    }
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(withRouter(PostTask));